/** Opens the selected source file in the case's document view; a recording at a second of it,
 *  and run to another when `untilSeconds` is given. */
export function documentPath(
  caseId: string,
  documentId: string,
  atSeconds?: number,
  untilSeconds?: number
): string {
  const at = atSeconds === undefined ? '' : `&docAt=${Math.max(0, Math.floor(atSeconds))}`
  const until =
    atSeconds === undefined || untilSeconds === undefined
      ? ''
      : `&docUntil=${Math.max(0, Math.ceil(untilSeconds))}`
  return `/cases/${caseId}/documents?doc=${encodeURIComponent(documentId)}${at}${until}`
}
